// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixed-toolbar {
   align-items: center;
   background-color: #fff;
   border-bottom: 1px solid #eaeaea;
   box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);
   position: fixed;
   left: 240px;
   top: 50px;
   height: 50px;
   right: 0;
   padding: 0 20px;
   z-index: 5;
}

app-dropbox-list {
   margin: 50px 20px;
   position: relative;
   transition: background-color .3s, opacity .3s;
}

.fixed-toolbar ul {
   list-style: none;
   margin: 0;
   padding: 0;
}

.breadcrumb1 {
   font-size: 18px;
   line-height: 30px;
   overflow: hidden;
   white-space: nowrap;
}

.breadcrumb1 li:first-child {
   display: inline-block;
   white-space: nowrap;
}

.breadcrumb1 li:not(:first-child) {
   overflow: hidden;
}

.breadcrumb1 li:last-child {
   flex: 1;
   min-width: 50px;
}

/* css for ie */

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .breadcrumb1 li:last-child {
      flex: 1 0 auto;
      min-width: 50px;
   }
}

/* ------------- */

.breadcrumb1 a {
   cursor: pointer;
}

.breadcrumb1 a, .breadcrumb1 span {
   overflow: hidden;
   text-overflow: ellipsis;
}

.breadcrumb1 li:not(:last-child):after {
   content: "\\f105";
   font-family: FontAwesome, sans-serif;
   padding: 0 5px;
   line-height: 32px;
   vertical-align: baseline;
}

.browse-folder {
   display: inline-block;
   margin-right: 5px;
   width: 24px;
   height: 24px;
   vertical-align: text-bottom;
}

.toolbar {
   align-items: center;
}

.menu>li {
   float: left;
}

.menu>li+li {
   margin-left: 1em;
}

.menu>li>a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu>li>a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open>a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu i {
   font-size: 16px;
}

.menu mat-icon {
   font-size: 20px;
   width: 20px;
   height: 20px;
}

.menu i+span, .menu mat-icon+span {
   margin-left: 10px;
}

.menu span+i {
   margin-left: 10px;
}

.menu button {
   min-width: 0;
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.separator {
   border: none;
   border-top: 1px solid #eaeaea;
   height: 0;
   margin: 5px 0;
}

.toolbar .dropdown-menu {
   left: auto;
   right: 0;
}

.file-upload {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

.drag-over {
   background-color: rgba(0, 188, 212, .2);
   opacity: .5;
}

/* Full-width inputs */

input[type=text], input[type=password], input[type=email] {
   width: 70%;
   padding: 10px 15px;
   margin: 0 0;
   display: inline-block;
   border: 1px solid #ccc;
   box-sizing: border-box;
}

.btn-x {
   margin-top: 5px;
   font-size: 18px;
}

.regisbtn {
   width: auto;
   padding: 10px 18px;
   background-color: #f44336;
}

/* Center the avatar image inside this container */

.imgcontainer {
   text-align: center;
   margin: 24px 0 12px 0;
}

/* Avatar image */

img.avatar {
   width: 30%;
   border-radius: 50%;
   /*margin-top: 50px;*/
}

/* Add padding to containers */

.container {
   padding: 16px;
}

/* The "Forgot password" text */

span.psw {
   float: right;
   padding-top: 16px;
}

/* Change styles for span and cancel button on extra small screens */

@media screen and (max-width: 300px) {
   span.psw {
      display: block;
      float: none;
   }
   .cancelbtn {
      width: 100%;
   }
}
@media only screen and (max-width: 480px) {
   app-dropbox-list {
      margin: 50px 20px 120px;
   }
}
@media only screen and (min-width: 480px) and (max-width: 768px) {
   app-dropbox-list {
      margin: 50px 20px 80px;
   }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
   app-dropbox-list {
      margin: 50px 20px 60px;
   }
}
.wrapper {
   text-align: center;
   /*text-align: left;*/
}

.star {
   font-size: 25px;
   color: grey;
}

nav {
   float: left;
   max-width: 160px;
   margin: 0;
   padding: 1em;
}

nav ul {
   list-style-type: none;
   height: 100%;
   position: fixed;
   width: 15%;
   background-color: #f4f5f7;
   overflow: auto;
}

nav ul a {
   text-decoration: none;
   display: block;
   color: #000;
   padding: 8px 16px;
}

#div2, #div3, #div4 {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

#snackbar {
   visibility: hidden;
   min-width: 250px;
   margin-left: -125px;
   background-color: #333;
   color: #fff;
   text-align: center;
   border-radius: 2px;
   padding: 16px;
   position: fixed;
   z-index: 1;
   left: 50%;
   bottom: 30px;
   font-size: 17px;
}

#snackbar.show {
   visibility: visible;
   animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

.errorBox.show {
   visibility: visible;
   animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

@keyframes fadein {
   from {
      bottom: 0;
      opacity: 0;
   }
   to {
      bottom: 30px;
      opacity: 1;
   }
}

@keyframes fadeout {
   from {
      bottom: 30px;
      opacity: 1;
   }
   to {
      bottom: 0;
      opacity: 0;
   }
}

#drop_zone.hover {
   color: #f00;
   border: solid #f00;
   box-shadow: inset 0 3px 4px #888;
}

#drop_zone {
   font-weight: bold;
   text-align: center;
   padding: 1em 0;
   margin: 1em 0;
   color: #555;
   border: 2px dashed #555;
   border-radius: 7px;
   cursor: default;
}

#noFiles {
   font-weight: bold;
   text-align: center;
   padding: 1em 0;
   margin: 1em 0;
   color: #555;
   /*border: 2px dashed #555;*/
   border-radius: 7px;
   cursor: default;
}

#div1 {
   width: 350px;
   height: 70px;
   padding: 10px;
   border: 1px solid #aaa;
}

#body_drop_zone {
   /*height: 65%;*/
   /*overflow: auto;*/
}

/*::-webkit-scrollbar-track*/

/*{*/

/*!*background-color: white;*!*/

/*border-radius: 7px ;*/

/*}*/

/*::-webkit-scrollbar*/

/*{*/

/*width: 12px;*/

/*border: 1px solid lightskyblue;*/

/*}*/

/*::-webkit-scrollbar-thumb*/

/*{*/

/*background-color: lightblue;*/

/*border-radius: 10px;*/

/*}*/

/*::-webkit-scrollbar-button*/

/*{*/

/*background-color: lightskyblue;*/

/*}*/

#progressDlg {
   /*animation: progressBar 3s ease-in-out;*/
   /*animation-fill-mode:both;*/
   -webkit-animation-name: example;
   /* Chrome, Safari, Opera */
   -webkit-animation-duration: 5s;
   /* Chrome, Safari, Opera */
   animation-name: example;
   animation-duration: 5s;
   animation-iteration-count: infinite;
}

@keyframes example {
   0% {
      background: #ff4d4d;
   }
   25% {
      background: #f66;
   }
   50% {
      background: #f99;
   }
   75% {
      background: #ffe5e5;
   }
   100% {
      background: #ff4d4d;
   }
   /*from {background-color:  #ff4d4d;}*/
   /*to {background-color: #ff6666;}*/
   /*to {background-color: #ff9999;}*/
   /*to {background-color: #ffe5e5;}*/
   /*to {background-color: white;}*/
}

#sideLeftdiv {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

#sideLeft {
   height: 65%;
   overflow-y: auto;
   /*overflow-x: hidden;*/
}

.modal-header {
   padding: 10px;
}

.modal-footer {
   padding: 10px;
}

.btnicon:before {
   font-family: "Glyphicons Halflings", sans-serif;
   content: "\\e114";
   font-size: 14px;
   margin-right: 5px
}

/* Icon when the collapsible content is hidden */

.btnicon.collapsed:before {
   content: "\\e080";
}

h5 {
   /*width: 60%;*/
   word-wrap: break-word;
   font-family: Arial, Helvetica, sans-serif;
   font-style: normal;
}

#sideBarLeft {
   /*border: 2px solid;*/
   /*padding: 20px;*/
   width: 150px;
   min-width: 150px;
   max-width: 350px;
   resize: horizontal;
   overflow: hidden;
   /*overflow: auto;*/
}

.disabledbutton {
   background-color: gainsboro;
   border-color: gainsboro;
}

.dlgProgress2 {
   right: 20px;
   top: 400px;
   position: absolute;
   height: auto;
   min-width: 360px;
   max-width: 400px;
   background-color: #fff;
   border: 1px solid #ccc;
   box-shadow: 1px 0 8px rgba(0, 0, 0, 0.3);
   color: #333;
   /*margin-top: 3px;*/
   z-index: 1000;
}

.floating-box {
   float: left;
   width: 300px;
   height: 100px;
   margin: 10px;
   border: 3px solid #73ad21;
}

.after-box {
   clear: left;
   border: 3px solid red;
}

.modal-content {
   margin: auto;
   background-color: #fff;
   position: relative;
   padding: 0;
   outline: 0;
   width: 600px
}

.modal {
   z-index: 100;
   display: none;
   padding-top: 100px;
   position: fixed;
   left: 0;
   top: 0;
   width: 100%;
   height: 100%;
   overflow: auto;
   background-color: rgb(0, 0, 0);
   background-color: rgba(0, 0, 0, 0.4)
}

.example-card {
   width: 400px;
   background-color: white;
   left: 40%;
   border: 1px solid #364150;
}

.example-section {
   display: flex;
   align-content: center;
   align-items: center;
   height: 60px;
}

.example-margin {
   margin: 0 10px;
}

.header_modal {
   /*border-bottom: 1px solid #364150;*/
   border-bottom: 1px solid #999;
}

.header_modal p {
   color: #364150;
   font-size: 20px;
   /*font-family: 'Open Sans';*/
   /*font-weight: bold;*/
}

.footer_modal {
   text-align: right;
   margin-top: -15px;
   /*margin: 5px*/
}

.footer_modal button {
   /*font-family: 'Open Sans';*/
   /*font-weight: bold;*/
   margin-top: 10px;
}

#footerbutton {
   border-top: 1px solid #364150;
   margin-top: 10px;
}

.chk-all {
   margin-top: 4px;
   margin-right: 9px;
}

.div-header-chk-all {
   display: inherit;
}

.menu em {
  font-size: 16px;
}

.menu mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.menu em+span, .menu mat-icon+span {
  margin-left: 10px;
}

.menu span+em {
  margin-left: 10px;
}

.menu button {
  min-width: 0;
  padding: 0 12px;
}

.menu button.mat-primary {
  line-height: 30px;
}

.menu button:not(.mat-primary) {
  border: 1px solid #bdc3c7;
  line-height: 28px;
}

.separator {
  border: none;
  border-top: 1px solid #eaeaea;
  height: 0;
  margin: 5px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/dms/dropbox-page/dropbox-page.component.css"],"names":[],"mappings":"AAAA;GACG,mBAAmB;GACnB,sBAAsB;GACtB,gCAAgC;GAChC,6CAA6C;GAC7C,eAAe;GACf,WAAW;GACX,SAAS;GACT,YAAY;GACZ,QAAQ;GACR,eAAe;GACf,UAAU;AACb;;AAEA;GACG,iBAAiB;GACjB,kBAAkB;GAClB,6CAA6C;AAChD;;AAEA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,eAAe;GACf,iBAAiB;GACjB,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,qBAAqB;GACrB,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,OAAO;GACP,eAAe;AAClB;;AAEA,eAAe;;AAEf;GACG;MACG,cAAc;MACd,eAAe;GAClB;AACH;;AAEA,kBAAkB;;AAElB;GACG,eAAe;AAClB;;AAEA;GACG,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,gBAAgB;GAChB,oCAAoC;GACpC,cAAc;GACd,iBAAiB;GACjB,wBAAwB;AAC3B;;AAEA;GACG,qBAAqB;GACrB,iBAAiB;GACjB,WAAW;GACX,YAAY;GACZ,2BAA2B;AAC9B;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,eAAe;GACf,WAAW;GACX,YAAY;AACf;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,YAAY;GACZ,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,YAAY;GACZ,6BAA6B;GAC7B,SAAS;GACT,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,QAAQ;AACX;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,uCAAuC;GACvC,WAAW;AACd;;AAEA,sBAAsB;;AAEtB;GACG,UAAU;GACV,kBAAkB;GAClB,WAAW;GACX,qBAAqB;GACrB,sBAAsB;GACtB,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,kBAAkB;GAClB,yBAAyB;AAC5B;;AAEA,kDAAkD;;AAElD;GACG,kBAAkB;GAClB,qBAAqB;AACxB;;AAEA,iBAAiB;;AAEjB;GACG,UAAU;GACV,kBAAkB;GAClB,oBAAoB;AACvB;;AAEA,8BAA8B;;AAE9B;GACG,aAAa;AAChB;;AAEA,+BAA+B;;AAE/B;GACG,YAAY;GACZ,iBAAiB;AACpB;;AAEA,oEAAoE;;AAEpE;GACG;MACG,cAAc;MACd,WAAW;GACd;GACA;MACG,WAAW;GACd;AACH;AACA;GACG;MACG,uBAAuB;GAC1B;AACH;AACA;GACG;MACG,sBAAsB;GACzB;AACH;AACA;GACG;MACG,sBAAsB;GACzB;AACH;AACA;GACG,kBAAkB;GAClB,oBAAoB;AACvB;;AAEA;GACG,eAAe;GACf,WAAW;AACd;;AAEA;GACG,WAAW;GACX,gBAAgB;GAChB,SAAS;GACT,YAAY;AACf;;AAEA;GACG,qBAAqB;GACrB,YAAY;GACZ,eAAe;GACf,UAAU;GACV,yBAAyB;GACzB,cAAc;AACjB;;AAEA;GACG,qBAAqB;GACrB,cAAc;GACd,WAAW;GACX,iBAAiB;AACpB;;AAEA;GACG,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,kBAAkB;GAClB,gBAAgB;GAChB,mBAAmB;GACnB,sBAAsB;GACtB,WAAW;GACX,kBAAkB;GAClB,kBAAkB;GAClB,aAAa;GACb,eAAe;GACf,UAAU;GACV,SAAS;GACT,YAAY;GACZ,eAAe;AAClB;;AAEA;GACG,mBAAmB;GAEnB,yCAAyC;AAC5C;;AAEA;GACG,mBAAmB;GAEnB,yCAAyC;AAC5C;;AAaA;GACG;MACG,SAAS;MACT,UAAU;GACb;GACA;MACG,YAAY;MACZ,UAAU;GACb;AACH;;AAaA;GACG;MACG,YAAY;MACZ,UAAU;GACb;GACA;MACG,SAAS;MACT,UAAU;GACb;AACH;;AAEA;GACG,WAAW;GACX,kBAAkB;GAClB,gCAAgC;AACnC;;AAEA;GACG,iBAAiB;GACjB,kBAAkB;GAClB,cAAc;GACd,aAAa;GACb,WAAW;GACX,uBAAuB;GACvB,kBAAkB;GAClB,eAAe;AAClB;;AAEA;GACG,iBAAiB;GACjB,kBAAkB;GAClB,cAAc;GACd,aAAa;GACb,WAAW;GACX,2BAA2B;GAC3B,kBAAkB;GAClB,eAAe;AAClB;;AAEA;GACG,YAAY;GACZ,YAAY;GACZ,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA,4BAA4B;;AAE5B,IAAI;;AAEJ,+BAA+B;;AAE/B,uBAAuB;;AAEvB,IAAI;;AAEJ,sBAAsB;;AAEtB,IAAI;;AAEJ,eAAe;;AAEf,kCAAkC;;AAElC,IAAI;;AAEJ,4BAA4B;;AAE5B,IAAI;;AAEJ,+BAA+B;;AAE/B,uBAAuB;;AAEvB,IAAI;;AAEJ,6BAA6B;;AAE7B,IAAI;;AAEJ,kCAAkC;;AAElC,IAAI;;AAEJ;GACG,yCAAyC;GACzC,4BAA4B;GAC5B,+BAA+B;GAC/B,0BAA0B;GAC1B,8BAA8B;GAC9B,0BAA0B;GAC1B,uBAAuB;GACvB,sBAAsB;GACtB,mCAAmC;AACtC;;AAEA;GACG;MACG,mBAAmB;GACtB;GACA;MACG,gBAAgB;GACnB;GACA;MACG,gBAAgB;GACnB;GACA;MACG,mBAAmB;GACtB;GACA;MACG,mBAAmB;GACtB;GACA,qCAAqC;GACrC,kCAAkC;GAClC,kCAAkC;GAClC,kCAAkC;GAClC,gCAAgC;AACnC;;AAEA;GACG,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,WAAW;GACX,gBAAgB;GAChB,sBAAsB;AACzB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,+CAA+C;GAC/C,gBAAgB;GAChB,eAAe;GACf;AACH;;AAEA,gDAAgD;;AAEhD;GACG,gBAAgB;AACnB;;AAEA;GACG,cAAc;GACd,qBAAqB;GACrB,yCAAyC;GACzC,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,iBAAiB;GACjB,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;GAChB,kBAAkB;GAClB,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,2BAA2B;GAC3B,uBAAuB;AAC1B;;AAEA;GACG,WAAW;GACX,UAAU;GACV,kBAAkB;GAClB,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;GAChB,sBAAsB;GACtB,sBAAsB;GACtB,wCAAwC;GACxC,WAAW;GACX,mBAAmB;GACnB,aAAa;AAChB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,aAAa;GACb,YAAY;GACZ,yBAAyB;AAC5B;;AAEA;GACG,WAAW;GACX,qBAAqB;AACxB;;AAEA;GACG,YAAY;GACZ,sBAAsB;GACtB,kBAAkB;GAClB,UAAU;GACV,UAAU;GACV;AACH;;AAEA;GACG,YAAY;GACZ,aAAa;GACb,kBAAkB;GAClB,eAAe;GACf,OAAO;GACP,MAAM;GACN,WAAW;GACX,YAAY;GACZ,cAAc;GACd,8BAA8B;GAC9B;AACH;;AAEA;GACG,YAAY;GACZ,uBAAuB;GACvB,SAAS;GACT,yBAAyB;AAC5B;;AAEA;GACG,aAAa;GACb,qBAAqB;GACrB,mBAAmB;GACnB,YAAY;AACf;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,oCAAoC;GACpC,6BAA6B;AAChC;;AAEA;GACG,cAAc;GACd,eAAe;GACf,4BAA4B;GAC5B,qBAAqB;AACxB;;AAEA;GACG,iBAAiB;GACjB,iBAAiB;GACjB,cAAc;AACjB;;AAEA;GACG,4BAA4B;GAC5B,qBAAqB;GACrB,gBAAgB;AACnB;;AAEA;GACG,6BAA6B;GAC7B,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,SAAS;EACT,aAAa;AACf","sourcesContent":[".fixed-toolbar {\n   align-items: center;\n   background-color: #fff;\n   border-bottom: 1px solid #eaeaea;\n   box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);\n   position: fixed;\n   left: 240px;\n   top: 50px;\n   height: 50px;\n   right: 0;\n   padding: 0 20px;\n   z-index: 5;\n}\n\napp-dropbox-list {\n   margin: 50px 20px;\n   position: relative;\n   transition: background-color .3s, opacity .3s;\n}\n\n.fixed-toolbar ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.breadcrumb1 {\n   font-size: 18px;\n   line-height: 30px;\n   overflow: hidden;\n   white-space: nowrap;\n}\n\n.breadcrumb1 li:first-child {\n   display: inline-block;\n   white-space: nowrap;\n}\n\n.breadcrumb1 li:not(:first-child) {\n   overflow: hidden;\n}\n\n.breadcrumb1 li:last-child {\n   flex: 1;\n   min-width: 50px;\n}\n\n/* css for ie */\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n   .breadcrumb1 li:last-child {\n      flex: 1 0 auto;\n      min-width: 50px;\n   }\n}\n\n/* ------------- */\n\n.breadcrumb1 a {\n   cursor: pointer;\n}\n\n.breadcrumb1 a, .breadcrumb1 span {\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n.breadcrumb1 li:not(:last-child):after {\n   content: \"\\f105\";\n   font-family: FontAwesome, sans-serif;\n   padding: 0 5px;\n   line-height: 32px;\n   vertical-align: baseline;\n}\n\n.browse-folder {\n   display: inline-block;\n   margin-right: 5px;\n   width: 24px;\n   height: 24px;\n   vertical-align: text-bottom;\n}\n\n.toolbar {\n   align-items: center;\n}\n\n.menu>li {\n   float: left;\n}\n\n.menu>li+li {\n   margin-left: 1em;\n}\n\n.menu>li>a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu>li>a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open>a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu i {\n   font-size: 16px;\n}\n\n.menu mat-icon {\n   font-size: 20px;\n   width: 20px;\n   height: 20px;\n}\n\n.menu i+span, .menu mat-icon+span {\n   margin-left: 10px;\n}\n\n.menu span+i {\n   margin-left: 10px;\n}\n\n.menu button {\n   min-width: 0;\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.separator {\n   border: none;\n   border-top: 1px solid #eaeaea;\n   height: 0;\n   margin: 5px 0;\n}\n\n.toolbar .dropdown-menu {\n   left: auto;\n   right: 0;\n}\n\n.file-upload {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n.drag-over {\n   background-color: rgba(0, 188, 212, .2);\n   opacity: .5;\n}\n\n/* Full-width inputs */\n\ninput[type=text], input[type=password], input[type=email] {\n   width: 70%;\n   padding: 10px 15px;\n   margin: 0 0;\n   display: inline-block;\n   border: 1px solid #ccc;\n   box-sizing: border-box;\n}\n\n.btn-x {\n   margin-top: 5px;\n   font-size: 18px;\n}\n\n.regisbtn {\n   width: auto;\n   padding: 10px 18px;\n   background-color: #f44336;\n}\n\n/* Center the avatar image inside this container */\n\n.imgcontainer {\n   text-align: center;\n   margin: 24px 0 12px 0;\n}\n\n/* Avatar image */\n\nimg.avatar {\n   width: 30%;\n   border-radius: 50%;\n   /*margin-top: 50px;*/\n}\n\n/* Add padding to containers */\n\n.container {\n   padding: 16px;\n}\n\n/* The \"Forgot password\" text */\n\nspan.psw {\n   float: right;\n   padding-top: 16px;\n}\n\n/* Change styles for span and cancel button on extra small screens */\n\n@media screen and (max-width: 300px) {\n   span.psw {\n      display: block;\n      float: none;\n   }\n   .cancelbtn {\n      width: 100%;\n   }\n}\n@media only screen and (max-width: 480px) {\n   app-dropbox-list {\n      margin: 50px 20px 120px;\n   }\n}\n@media only screen and (min-width: 480px) and (max-width: 768px) {\n   app-dropbox-list {\n      margin: 50px 20px 80px;\n   }\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n   app-dropbox-list {\n      margin: 50px 20px 60px;\n   }\n}\n.wrapper {\n   text-align: center;\n   /*text-align: left;*/\n}\n\n.star {\n   font-size: 25px;\n   color: grey;\n}\n\nnav {\n   float: left;\n   max-width: 160px;\n   margin: 0;\n   padding: 1em;\n}\n\nnav ul {\n   list-style-type: none;\n   height: 100%;\n   position: fixed;\n   width: 15%;\n   background-color: #f4f5f7;\n   overflow: auto;\n}\n\nnav ul a {\n   text-decoration: none;\n   display: block;\n   color: #000;\n   padding: 8px 16px;\n}\n\n#div2, #div3, #div4 {\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n#snackbar {\n   visibility: hidden;\n   min-width: 250px;\n   margin-left: -125px;\n   background-color: #333;\n   color: #fff;\n   text-align: center;\n   border-radius: 2px;\n   padding: 16px;\n   position: fixed;\n   z-index: 1;\n   left: 50%;\n   bottom: 30px;\n   font-size: 17px;\n}\n\n#snackbar.show {\n   visibility: visible;\n   -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;\n   animation: fadein 0.5s, fadeout 0.5s 2.5s;\n}\n\n.errorBox.show {\n   visibility: visible;\n   -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;\n   animation: fadein 0.5s, fadeout 0.5s 2.5s;\n}\n\n@-webkit-keyframes fadein {\n   from {\n      bottom: 0;\n      opacity: 0;\n   }\n   to {\n      bottom: 30px;\n      opacity: 1;\n   }\n}\n\n@keyframes fadein {\n   from {\n      bottom: 0;\n      opacity: 0;\n   }\n   to {\n      bottom: 30px;\n      opacity: 1;\n   }\n}\n\n@-webkit-keyframes fadeout {\n   from {\n      bottom: 30px;\n      opacity: 1;\n   }\n   to {\n      bottom: 0;\n      opacity: 0;\n   }\n}\n\n@keyframes fadeout {\n   from {\n      bottom: 30px;\n      opacity: 1;\n   }\n   to {\n      bottom: 0;\n      opacity: 0;\n   }\n}\n\n#drop_zone.hover {\n   color: #f00;\n   border: solid #f00;\n   box-shadow: inset 0 3px 4px #888;\n}\n\n#drop_zone {\n   font-weight: bold;\n   text-align: center;\n   padding: 1em 0;\n   margin: 1em 0;\n   color: #555;\n   border: 2px dashed #555;\n   border-radius: 7px;\n   cursor: default;\n}\n\n#noFiles {\n   font-weight: bold;\n   text-align: center;\n   padding: 1em 0;\n   margin: 1em 0;\n   color: #555;\n   /*border: 2px dashed #555;*/\n   border-radius: 7px;\n   cursor: default;\n}\n\n#div1 {\n   width: 350px;\n   height: 70px;\n   padding: 10px;\n   border: 1px solid #aaa;\n}\n\n#body_drop_zone {\n   /*height: 65%;*/\n   /*overflow: auto;*/\n}\n\n/*::-webkit-scrollbar-track*/\n\n/*{*/\n\n/*!*background-color: white;*!*/\n\n/*border-radius: 7px ;*/\n\n/*}*/\n\n/*::-webkit-scrollbar*/\n\n/*{*/\n\n/*width: 12px;*/\n\n/*border: 1px solid lightskyblue;*/\n\n/*}*/\n\n/*::-webkit-scrollbar-thumb*/\n\n/*{*/\n\n/*background-color: lightblue;*/\n\n/*border-radius: 10px;*/\n\n/*}*/\n\n/*::-webkit-scrollbar-button*/\n\n/*{*/\n\n/*background-color: lightskyblue;*/\n\n/*}*/\n\n#progressDlg {\n   /*animation: progressBar 3s ease-in-out;*/\n   /*animation-fill-mode:both;*/\n   -webkit-animation-name: example;\n   /* Chrome, Safari, Opera */\n   -webkit-animation-duration: 5s;\n   /* Chrome, Safari, Opera */\n   animation-name: example;\n   animation-duration: 5s;\n   animation-iteration-count: infinite;\n}\n\n@keyframes example {\n   0% {\n      background: #ff4d4d;\n   }\n   25% {\n      background: #f66;\n   }\n   50% {\n      background: #f99;\n   }\n   75% {\n      background: #ffe5e5;\n   }\n   100% {\n      background: #ff4d4d;\n   }\n   /*from {background-color:  #ff4d4d;}*/\n   /*to {background-color: #ff6666;}*/\n   /*to {background-color: #ff9999;}*/\n   /*to {background-color: #ffe5e5;}*/\n   /*to {background-color: white;}*/\n}\n\n#sideLeftdiv {\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n#sideLeft {\n   height: 65%;\n   overflow-y: auto;\n   /*overflow-x: hidden;*/\n}\n\n.modal-header {\n   padding: 10px;\n}\n\n.modal-footer {\n   padding: 10px;\n}\n\n.btnicon:before {\n   font-family: \"Glyphicons Halflings\", sans-serif;\n   content: \"\\e114\";\n   font-size: 14px;\n   margin-right: 5px\n}\n\n/* Icon when the collapsible content is hidden */\n\n.btnicon.collapsed:before {\n   content: \"\\e080\";\n}\n\nh5 {\n   /*width: 60%;*/\n   word-wrap: break-word;\n   font-family: Arial, Helvetica, sans-serif;\n   font-style: normal;\n}\n\n#sideBarLeft {\n   /*border: 2px solid;*/\n   /*padding: 20px;*/\n   width: 150px;\n   min-width: 150px;\n   max-width: 350px;\n   resize: horizontal;\n   overflow: hidden;\n   /*overflow: auto;*/\n}\n\n.disabledbutton {\n   background-color: gainsboro;\n   border-color: gainsboro;\n}\n\n.dlgProgress2 {\n   right: 20px;\n   top: 400px;\n   position: absolute;\n   height: auto;\n   min-width: 360px;\n   max-width: 400px;\n   background-color: #fff;\n   border: 1px solid #ccc;\n   box-shadow: 1px 0 8px rgba(0, 0, 0, 0.3);\n   color: #333;\n   /*margin-top: 3px;*/\n   z-index: 1000;\n}\n\n.floating-box {\n   float: left;\n   width: 300px;\n   height: 100px;\n   margin: 10px;\n   border: 3px solid #73ad21;\n}\n\n.after-box {\n   clear: left;\n   border: 3px solid red;\n}\n\n.modal-content {\n   margin: auto;\n   background-color: #fff;\n   position: relative;\n   padding: 0;\n   outline: 0;\n   width: 600px\n}\n\n.modal {\n   z-index: 100;\n   display: none;\n   padding-top: 100px;\n   position: fixed;\n   left: 0;\n   top: 0;\n   width: 100%;\n   height: 100%;\n   overflow: auto;\n   background-color: rgb(0, 0, 0);\n   background-color: rgba(0, 0, 0, 0.4)\n}\n\n.example-card {\n   width: 400px;\n   background-color: white;\n   left: 40%;\n   border: 1px solid #364150;\n}\n\n.example-section {\n   display: flex;\n   align-content: center;\n   align-items: center;\n   height: 60px;\n}\n\n.example-margin {\n   margin: 0 10px;\n}\n\n.header_modal {\n   /*border-bottom: 1px solid #364150;*/\n   border-bottom: 1px solid #999;\n}\n\n.header_modal p {\n   color: #364150;\n   font-size: 20px;\n   /*font-family: 'Open Sans';*/\n   /*font-weight: bold;*/\n}\n\n.footer_modal {\n   text-align: right;\n   margin-top: -15px;\n   /*margin: 5px*/\n}\n\n.footer_modal button {\n   /*font-family: 'Open Sans';*/\n   /*font-weight: bold;*/\n   margin-top: 10px;\n}\n\n#footerbutton {\n   border-top: 1px solid #364150;\n   margin-top: 10px;\n}\n\n.chk-all {\n   margin-top: 4px;\n   margin-right: 9px;\n}\n\n.div-header-chk-all {\n   display: inherit;\n}\n\n.menu em {\n  font-size: 16px;\n}\n\n.menu mat-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n}\n\n.menu em+span, .menu mat-icon+span {\n  margin-left: 10px;\n}\n\n.menu span+em {\n  margin-left: 10px;\n}\n\n.menu button {\n  min-width: 0;\n  padding: 0 12px;\n}\n\n.menu button.mat-primary {\n  line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n  border: 1px solid #bdc3c7;\n  line-height: 28px;\n}\n\n.separator {\n  border: none;\n  border-top: 1px solid #eaeaea;\n  height: 0;\n  margin: 5px 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
